import { Component, AfterViewInit, ElementRef } from '@angular/core';

@Component({
  standalone: true,
  imports: [],
  selector: 'app-qrcode',
  templateUrl: './qrcode.component.html',
  styleUrls: ['./qrcode.component.css']
})
export class QrcodeComponent implements AfterViewInit {

  constructor(private el: ElementRef) {}

  ngAfterViewInit(): void {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );

    const animatedEls: NodeListOf<Element> = this.el.nativeElement.querySelectorAll('.anim');
    animatedEls.forEach((el: Element) => observer.observe(el));
  }
}
